// @ts-nocheck
import React from 'react';
import dynamic from 'next/dynamic';
import HeadNext from 'next/head';
import NextDefaultError from 'next/error';
import useServerEnv from '@magalu/rave/config/useServerEnv';
import useClientEnv from '@magalu/rave/config/useClientEnv';

import { client , useClient  } from '@magalu/rave/graphql';
import { parseHeaders, shouldRender, middlewareClientExecutor, middlewareServerExecutor } from '@magalu/rave/utils';
import { withEventsLayer } from '@magalu/rave/hocs';

import { ErrorBoundary } from '@magalu/rave/errorBoundary';

import events , { config as eventsConfig }   from '../../events';

import { Head } from '@magalu/rave/components';
import { LazyLoading } from '@magalu/rave/components';
import { ActivityDetection } from '@magalu/rave/components';

// Modules
import { Preconnect } from '@magalu/rave/components';
import { Script } from '@magalu/rave/components';
import AllIn from '@magalu/ecomm-components/rave/scripts/AllIn';
import Criteo from '@magalu/ecomm-components/rave/scripts/Criteo';
import TikTok from '@magalu/ecomm-components/rave/scripts/TikTok';
import RTBHouse from '@magalu/ecomm-components/rave/scripts/RTBHouse';
import Stewie from '@magalu/ecomm-components/rave/scripts/Stewie';
import SpotifyAdAnalytics from '@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics';
import Hotjar from '@magalu/ecomm-components/rave/scripts/Hotjar';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Loader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Loader'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const StateLoader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/StateLoader'), {
  ssr: false
});
import EventPageViewDispatcher from '@magalu/ecomm-components/rave/EventPageViewDispatcher';
import PageLoading from '@magalu/ecomm-components/components/PageLoading';
import Row from '@magalu/ecomm-components/components/Row';
import EmptyReviewButton from '@magalu/ecomm-components/rave/EmptyReviewButton';
import ProductReviewInfoBasic from '@magalu/ecomm-components/rave/ProductReviewInfoCard';
import ReviewStats from '@magalu/ecomm-components/rave/ReviewStats';
import Button from '@magalu/ecomm-components/rave/Button';
import ProductReviewMediaCarousel from '@magalu/ecomm-components/components/ProductReviewMediaCarousel';
import Heading from '@magalu/ecomm-components/rave/Heading';
import ReviewFilters from '@magalu/ecomm-components/rave/ReviewFilters';
import ReviewListing from '@magalu/ecomm-components/rave/ReviewListing';
import ReviewPaginationButton from '@magalu/ecomm-components/rave/ReviewPaginationButton';
import VersionTag from '../../modules/VersionTag';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const BackToTop = dynamic<any>(() =>
  import('@magalu/ecomm-components/components/BackToTop'), {
  ssr: false
});

// Middlewares
import getAppTheme from '@magalu/ecomm-components/rave/middlewares/getAppTheme';
import getUserInfo from '@magalu/ecomm-components/rave/middlewares/getUserInfo';
import getVersions from '../../middlewares/getVersions';
import writePromoterIdCookie from '@magalu/ecomm-components/rave/middlewares/writePromoterIdCookie';

// Data Source
import PageQuery from './query.json';

// Data Source Configs
import { configs as dataSourceConfigs } from '../../datasource/config';
const { cachePolicies = {}, localTypeDefs,  linkMiddlewares = [] } = dataSourceConfigs  as any ;
import { getParsedQuery, useRouter, useCookies, withRouter, getDeviceInfo } from '@magalu/rave/router';
import { withClientData } from '@magalu/rave/hocs';


import {
    getGlobalClassName, routeInfo, getComponents, getHeadProps,
    dataSource, getPageVariables, middlewaresArgs,
    manifest, config as raveConfig, componentsList
  } from './settings';

import routes from '../../rave-routes';

const Custom404 = dynamic(() => import('../../containers/notfound').catch(() => null));
const CustomError = dynamic(() =>
  import('../../containers/internalError').catch(() => NextDefaultError)
);

const Container = (props : Record<string, any>  = {}) => {

  const { client: clientConfig } = useClientEnv();
  const route = useRouter();

  const pageProps = { ...props, route, manifest, appConfig: raveConfig, clientConfig };

  const headProps = getHeadProps(pageProps);

  const componentProps = getComponents(pageProps);
  const className = getGlobalClassName(pageProps);
  const gridStyleHtml = {__html: `#review-list{display: grid;grid-template-areas: 'header header header' '. content .' 'footer footer footer';grid-template-columns: 1fr 100% 1fr;grid-template-rows: 100px min(500px, auto) 100px;}`}


  return (
    <>
      <HeadNext><style dangerouslySetInnerHTML={gridStyleHtml}/></HeadNext>
      <div id="review-list" className={className}>
        <Head {...props} {...headProps} />
          <header { ...{"style":{"gridArea":"header"}} }>
            
            
            
            
            <Preconnect { ...props} {...(componentProps['header-preconnect-0']?.props || {})}/>
            
            
            
            
            
            
            
            <Script { ...props} {...(componentProps['header-script-1']?.props || {})}/>
            
            
            
            
            
            
            
            <AllIn { ...props} {...(componentProps['header-all-in-2']?.props || {})}/>
            
            
            
            
            
            
            
            <Criteo { ...props} {...(componentProps['header-criteo-3']?.props || {})}/>
            
            
            
            
            
            
            
            <TikTok { ...props} {...(componentProps['header-tik-tok-4']?.props || {})}/>
            
            
            
            
            
            
            
            <RTBHouse { ...props} {...(componentProps['header-rtbhouse-5']?.props || {})}/>
            
            
            
            
            
            
            
            <Stewie { ...props} {...(componentProps['header-stewie-6']?.props || {})}/>
            
            
            
            
            
            
            
            <SpotifyAdAnalytics { ...props} {...(componentProps['header-spotify-ad-analytics-7']?.props || {})}/>
            
            
            
            
            
            
            
            <Hotjar { ...props} {...(componentProps['header-hotjar-8']?.props || {})}/>
            
            
            
            
            <ActivityDetection {...componentProps['header-loader-9'].csr.props}>
            
            
             
            <Loader { ...props} {...(componentProps['header-loader-9']?.props || {})}>
            
            
            
            
            <PageLoading { ...props} {...(componentProps['header-loader-9-children-page-loading-0']?.props || {})}/>
            
            
            
             
            </Loader>
            
            </ActivityDetection>
            
            
            <ActivityDetection {...componentProps['header-state-loader-10'].csr.props}>
            
            
             
            <StateLoader { ...props} {...(componentProps['header-state-loader-10']?.props || {})}>
            
            <ActivityDetection {...componentProps['header-state-loader-10-children-page-loading-0'].csr.props}>
            
            
            <PageLoading { ...props} {...(componentProps['header-state-loader-10-children-page-loading-0']?.props || {})}/>
            
            </ActivityDetection>
            
             
            </StateLoader>
            
            </ActivityDetection>
            
            
            
            
            
            <EventPageViewDispatcher { ...props} {...(componentProps['header-event-page-view-dispatcher-11']?.props || {})}/>
            
            
            
          </header>
          <section { ...{"style":{"gridArea":"content"}} }>
            <LazyLoading {...componentProps['content-row-0'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0']?.props || {})}>
            {shouldRender(componentProps['content-row-0-children-empty-review-button-0']) &&
            
            
            
            
            <EmptyReviewButton { ...props} {...(componentProps['content-row-0-children-empty-review-button-0']?.props || {})}/>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-0-children-row-1']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0-children-row-1']?.props || {})}>
            
            
            
            
            <ProductReviewInfoBasic { ...props} {...(componentProps['content-row-0-children-row-1-children-product-review-info-basic-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <ReviewStats { ...props} {...(componentProps['content-row-0-children-row-1-children-review-stats-1']?.props || {})}/>
            
            
            
             
            {shouldRender(componentProps['content-row-0-children-row-1-children-row-2']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0-children-row-1-children-row-2']?.props || {})}>
            {shouldRender(componentProps['content-row-0-children-row-1-children-row-2-children-button-0']) &&
            
            
            
            
            <Button { ...props} {...(componentProps['content-row-0-children-row-1-children-row-2-children-button-0']?.props || {})}/>
            
            
            
            }
             
            </Row>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-0-children-row-1-children-row-3']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0-children-row-1-children-row-3']?.props || {})}>
            {shouldRender(componentProps['content-row-0-children-row-1-children-row-3-children-product-review-media-carousel-0']) &&
            
            
            
            
            <ProductReviewMediaCarousel { ...props} {...(componentProps['content-row-0-children-row-1-children-row-3-children-product-review-media-carousel-0']?.props || {})}/>
            
            
            
            }
             
            </Row>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-0-children-row-1-children-row-4']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0-children-row-1-children-row-4']?.props || {})}>
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-0-children-row-1-children-row-4-children-heading-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <ReviewFilters { ...props} {...(componentProps['content-row-0-children-row-1-children-row-4-children-review-filters-1']?.props || {})}/>
            
            
            
             
            
            
            
            
            <ReviewListing { ...props} {...(componentProps['content-row-0-children-row-1-children-row-4-children-review-listing-2']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
            }
             
            </Row>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-0-children-row-2']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0-children-row-2']?.props || {})}>
            
            
            
            
            <ReviewPaginationButton { ...props} {...(componentProps['content-row-0-children-row-2-children-review-pagination-button-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
            }
             
            </Row>
            
            
            </LazyLoading>
          </section>
          <footer { ...{"style":{"gridArea":"footer"}} }>
            
            
            
            
            <VersionTag { ...props} {...(componentProps['footer-version-tag-0']?.props || {})}/>
            
            
            
            
            <ActivityDetection {...componentProps['footer-back-to-top-1'].csr.props}>
            
            
            <BackToTop { ...props} {...(componentProps['footer-back-to-top-1']?.props || {})}/>
            
            </ActivityDetection>
            
          </footer>
      </div>
    </>
  )
};

let clientProps = {};
clientProps.manifest = manifest;
clientProps.appConfig = raveConfig || {};
clientProps.route = {
  id: routeInfo.id,
  name: routeInfo.name,
  pathPattern: routeInfo.pathPattern,
  pathAliases: routeInfo.pathAliases,
  renderMethod: routeInfo.renderMethod
};
clientProps.isServerRequest = false;
clientProps.componentsList = componentsList;

  const clientSideBeforeFetchMiddlewares = [
    { id: 'getAppTheme', functionMiddleware: getAppTheme },
    { id: 'getUserInfo', functionMiddleware: getUserInfo },
    { id: 'getVersions', functionMiddleware: getVersions },
    { id: 'writePromoterIdCookie', functionMiddleware: writePromoterIdCookie },
  ];

  const clientSideAfterFetchMiddlewares = [
  ];

export default withRouter(
  withClientData(
    withEventsLayer(
      Container,
      {
        routeInfo,
        events: events(),
        eventsCustomConfig: eventsConfig,
        dataStoreSetupKey: "userInfo",
        clientProps,
      }
    ),
    {
    pageQuery: PageQuery,
    getPageVariables,
    middlewares: {
      clientProps,
      clientSideBeforeFetchMiddlewares,
      clientSideAfterFetchMiddlewares,
      middlewaresArgs,
    },
  }),
  { ...routeInfo, manifest },
  false,
  routes
);

